<template>
  <div class="d-flex justify-content-center align-items-center">
    <span
      class="anzahl-badge"
      :class="{
        'anzahl-badge--mehrere': anzahl > 1,
        'anzahl-badge--clickable': isClickable,
      }"
      @click.stop="onBadgeClick"
    >
      {{ anzahl }}
    </span>
  </div>
</template>

<script>
// Badge mit der Anzahl der Teilbeträge einer Leistung
export default {
  name: 'CellRendererAnzahlLeistungen',
  computed: {
    // AG Grid injiziert params als data, die b-table uebergibt sie als Attribut
    cellParams() {
      return this.params ?? this.$attrs.params;
    },
    anzahl() {
      return this.cellParams?.data?.teilbetraege?.length ?? 0;
    },
    isClickable() {
      return this.anzahl > 1 && this.cellParams?.clickable !== false;
    },
  },
  methods: {
    onBadgeClick() {
      if (!this.isClickable) return;
      const onToggle = this.cellParams?.onToggle;
      const leistungId = this.cellParams?.data?.id;
      if (typeof onToggle === 'function' && leistungId != null) {
        onToggle(leistungId);
      }
    },
  },
};
</script>

<style scoped>
.anzahl-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 22px;
  border-radius: 8px;
  border: 0.5px solid var(--border-strong);
  font-weight: 500;
  background-color: #b5b5c34d;
  color: #5e6278;
}
.anzahl-badge--mehrere {
  border-color: var(--primary);
  background-color: #3699ff26;
  color: var(--primary);
}
.anzahl-badge--clickable {
  cursor: pointer;
}
</style>
